import { CustomDateRange as AntdCustomDateRange, DateRangePickerOne as AntdDateRangePickerOne } from "@empglabs/backoffice-ui-kit"

export const DateRangePickerOne = props => {
  return <AntdDateRangePickerOne {...props} />
}

export const CustomDateRange = props => {
  return <AntdCustomDateRange {...props} />
}
